/**
 * Broker/Team Configuration
 * Centralized config for team member details
 */

export interface OfficeAddress {
  line1: string;
  line2?: string;
  suburb: string;
  state: string;
  postcode: string;
  mapUrl: string;
}

export interface TeamMember {
  id: string;
  name: string;
  role: string;
  email: string;
  phone: string;
  image: string;
  bio: string;
  shortBio: string;
  qualifications?: string[];
  specialties?: string[];
  socials?: {
    linkedin?: string;
    facebook?: string;
    instagram?: string;
  };
  googleReviewUrl?: string;
  googleBusinessUrl?: string;
}

export const office: OfficeAddress = {
  line1: "PO Box 4461",
  suburb: "Springfield Central",
  state: "QLD",
  postcode: "4300",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Orion+Springfield+Central+1+Main+Street+Springfield+Central+QLD+4300",
};

export const broker: TeamMember = {
  id: "cajetan-silva",
  name: "Cajetan (CJ) Silva",
  role: "Principal Broker",
  email: "cjsilva@pathfinancial.com.au",
  phone: "0477 308 028",
  image: "/people/Cajetan Photo.JPG",
  shortBio:
    "Helping Australians navigate the home loan journey with personalised guidance and access to 70+ lenders.",
  bio: `With more than 20 years of experience in the mortgage industry, Cajetan (CJ) Silva founded Path Financial Solutions to provide Australians with expert, personalised mortgage broking services.

CJ believes that finding the right home loan shouldn't be stressful or confusing. That's why he takes the time to understand each client's unique situation, goals, and financial circumstances before recommending the best options from over 70 lenders.

CJ combines industry expertise with a genuine passion for helping people achieve their property dreams—whether it's buying a first home, refinancing for a better rate, or building an investment portfolio.

His approach is simple: provide honest advice, compare the market thoroughly, handle the paperwork, and guide clients every step of the way to settlement and on-going.`,
  qualifications: [
    "Diploma of Finance and Mortgage Broking Management",
    "Certificate IV Financial Services (Finance/Mortgage Broking)",
    "Full Member of Mortgage and Finance Association of Australia (MFAA)",
    "Full Member of Australian Financial Complaints Authority (AFCA)",
  ],
  specialties: [
    "First Home Buyers",
    "Refinancing",
    "Investment Properties",
    "Self-Employed Lending",
    "Construction Loans",
    "Debt Consolidation",
    "Asset Finance",
  ],
  socials: {
    linkedin: "https://linkedin.com/in/cajetansilva",
    facebook: "https://facebook.com/pathfinancialsolutions",
  },
  googleReviewUrl:
    "https://www.google.com/search?q=Path+Financial+Solutions+Reviews#lrd=0x405669310d17b0f5:0xeba4d4021f1f94a7,3,,,,",
  googleBusinessUrl: "https://www.google.com/maps?cid=16979929600670799015",
};

/**
 * Team array for future expansion
 */
export const team: TeamMember[] = [broker];

/**
 * Get primary broker (convenience export)
 */
export const primaryBroker = broker;
